module.exports = require("./id.d.ts");